<template>
  <router-view />
</template>

<script setup lang="ts"></script>

<style>
@reference "./assets/theme.css";

#app {
  width: 100vw;
  height: 100vh;
  max-width: 100%;
}

body {
  @apply bg-gray-100 dark:bg-neutral-900;
}

/* TODO: remove */
.p-autocomplete-input,
.p-inputtext {
  width: 100%;
}

.p-button {
  padding: 0.5rem 1rem;
}
</style>
